import axios from "axios";

// Create an Axios instance without a baseURL
const axiosInstance = axios.create();

// Add a response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    const { status, isuserlogout, message } = response?.data || {};
    const sessionExpiredMessages = [
      "Session expired. Please login again.",
      "Authentication Error!",
      "session expired",
      "Authentication Errroor!",
      "Unauthorized. Device has been removed."
    ];

    if (
      status === false &&
      (isuserlogout || sessionExpiredMessages.includes(message))
    ) {
      handleLogout("Session expired or authentication error.");
      return Promise.reject({
        response,
        customMessage: "Session expired or authentication error.",
      });
    }

    return response;
  },
  (error) => {
    const { response } = error;

    // Handle 401 Unauthorized
    if (response?.status === 401) {
      const message = response?.data?.message || "Unauthorized access";
      handleLogout(message);
      return Promise.reject({
        response,
        customMessage: message,
      });
    }

    // Log and pass through other errors
    console.error("Axios error:", error);
    return Promise.reject(error);
  }
);

// Logout handler function
const handleLogout = (message) => {
  localStorage.removeItem("token");
  localStorage.removeItem("userId");
  localStorage.removeItem("userData");
  localStorage.removeItem("isPinVerified");
  localStorage.removeItem("completed");

  setTimeout(() => {
    localStorage.setItem("login", true);
    window.location.href = "/";
    setTimeout(() => {
      window.history.pushState(null, "", "/");
      window.history.pushState(null, "", "/");
    }, 500);
  }, 1000);

  console.warn("Logout triggered:", message);
};

export default axiosInstance;
